import { gql } from '@apollo/client';
import { CART_DATA_DEFAULT_RESULT_PROPS } from './constants';

const GET_CART_QUERY = gql`
  query ecommerceGetCart($id: String!, $currency: String) {
    cartData: ecommerceGetCart(id: $id, currency: $currency) {
      ${CART_DATA_DEFAULT_RESULT_PROPS}
    }
  }
`;

const GET_USER_ADDRESSES = gql`
  query getUserAddresses {
    userAddresses: getUserAddresses {
      isDefaultBilling
      isDefaultShipping
      id
      title
      firstname
      lastname
      company
      country
      countryName
      county
      countyName
      address1
      address2
      city
      postcode
      tel
    }
  }
`;

export { GET_CART_QUERY, GET_USER_ADDRESSES };
